export enum Goal {
    DarkGaia = 0,
    RedJewelHunt = 1,
    ApocalypseGaia = 2,
    RandomGaia = 3,
}
